import "./ProductContainer.css";

export const ProductContainer = ({ children }) => {
  return <section className="product-container">{children}</section>;
};
